import './productSpecsManuals.scss';

import ProductClearances from './ProductClearances';
import ProductManuals from './ProductManuals';
import ProductSpecs from './ProductSpecs';
import ProductSubTitle from './ProductSubTitle';
import React from 'react';

type ProductSpecsManualsProps = {
    product: Queries.ProductJsonTemplateFragment;
    lang: string;
    documents: Queries.ProductJsonDocumentsFragment[];
};

export default function ProductSpecsManuals(props: ProductSpecsManualsProps) {
    const { product, lang, documents } = props;

    return (
        <div className='product-specs-manuals'>
            <ProductSubTitle textKey='specs-manuals-title' />
            <div className='product-specs-manuals-container'>
                <div className='product-specs-container'>
                    <ProductSpecs product={product} />
                </div>
                <div className='product-manuals-container'>
                    <ProductManuals
                        documents={documents}
                        lang={lang}
                        product={product}
                    />
                </div>
            </div>
            <ProductClearances product={product} />
        </div>
    );
}
